import DOMPurify from "dompurify";
import { marked } from "marked";

const purifierConfig = {
  USE_PROFILES: { html: true },
};

export function sanitizeHTML(html) {
  if (!html) {
    return "";
  }
  return DOMPurify.sanitize(String(html), purifierConfig);
}

export function renderSafeMarkdown(text) {
  if (!text) {
    return "";
  }
  return sanitizeHTML(marked.parse(String(text), { breaks: true, gfm: true }));
}
